// Office kiosk device session.
//
// The kiosk page (/office-timelog) does not use a user login. A machine is
// activated once with an admin-generated one-time code and receives a
// long-lived device token, stored in this browser only. Every kiosk request
// then carries it in the X-Kiosk-Token header (never the admin bearer token).
import axios from 'axios'
import { server_details } from './config'

const TOKEN_KEY = 'office_kiosk_token'
const DEVICE_KEY = 'office_kiosk_device'

export function getKioskToken() {
  try { return localStorage.getItem(TOKEN_KEY) } catch (e) { return null }
}

export function setKioskSession(token, device) {
  try {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(DEVICE_KEY, JSON.stringify(device || {}))
  } catch (e) { /* storage unavailable */ }
}

export function getKioskDevice() {
  try { return JSON.parse(localStorage.getItem(DEVICE_KEY) || 'null') } catch (e) { return null }
}

export function clearKioskSession() {
  try {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(DEVICE_KEY)
  } catch (e) { /* storage unavailable */ }
}

// Informational only - shown to the admin so a machine is recognizable.
export function deviceFingerprint() {
  const parts = []
  try {
    parts.push(navigator.platform || '')
    parts.push(screen.width + 'x' + screen.height)
    parts.push(navigator.userAgent || '')
  } catch (e) { /* ignore */ }
  return parts.filter(p => p !== '').join(' | ')
}

export function defaultDeviceName() {
  let os = 'PC'
  try {
    const ua = navigator.userAgent
    if (/Windows/i.test(ua)) os = 'Windows PC'
    else if (/Android/i.test(ua)) os = 'Android device'
    else if (/iPhone|iPad/i.test(ua)) os = 'iOS device'
    else if (/Mac OS/i.test(ua)) os = 'Mac'
    else if (/Linux/i.test(ua)) os = 'Linux PC'
  } catch (e) { /* ignore */ }
  return 'Office Kiosk (' + os + ')'
}

// Dedicated axios instance: same API base URL, kiosk token instead of the
// user's bearer token.
export const kioskAxios = axios.create({ baseURL: server_details.SERVER_URL })

kioskAxios.interceptors.request.use(config => {
  const token = getKioskToken()
  if (token) config.headers['X-Kiosk-Token'] = token
  if (config.headers.Authorization) delete config.headers.Authorization
  if (config.headers.common && config.headers.common.Authorization) delete config.headers.common.Authorization
  return config
})

export function isKioskUnauthorized(error) {
  return !!(error && error.response && error.response.status === 401)
}
